/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebEditUserModel
 */
export interface FrontWebEditUserModel {
    /**
     * username
     * @type {string}
     * @memberof FrontWebEditUserModel
     */
    username: string;
    /**
     * password
     * @type {string}
     * @memberof FrontWebEditUserModel
     */
    password: string;
}

/**
 * Check if a given object implements the FrontWebEditUserModel interface.
 */
export function instanceOfFrontWebEditUserModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function FrontWebEditUserModelFromJSON(json: any): FrontWebEditUserModel {
    return FrontWebEditUserModelFromJSONTyped(json, false);
}

export function FrontWebEditUserModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebEditUserModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function FrontWebEditUserModelToJSON(value?: FrontWebEditUserModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

